import axios from '@/utils/api'

const state = {}

const getters = {}

const actions = {
  async salvar ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `despacho/salvar`
    })
    return data
  },

  async finalizar ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `despacho/finalizar`
    })
    return data
  },

  async getArrayTituloByDespachoId ({ commit }, despachoId) {
    const data = await axios({
      method: 'GET',
      responseType: 'arraybuffer',
      url: `despacho/pdf/titulo/${despachoId}`
    })
    return data
  },

  async getArrayRetificacaoTituloByDespachoId ({ commit }, despachoId) {
    const data = await axios({
      method: 'GET',
      responseType: 'arraybuffer',
      url: `despacho/pdf/retificacao/titulo/${despachoId}`
    })
    return data
  },

  async getArrayExtratoSentencaByDespachoId ({ commit }, despachoId) {
    const data = await axios({
      method: 'GET',
      responseType: 'arraybuffer',
      url: `despacho/pdf/extratoSentenca/${despachoId}`
    })
    return data
  },

  async getArrayCertidaoAreaByDespachoId ({ commit }, despachoId) {
    const data = await axios({
      method: 'GET',
      responseType: 'arraybuffer',
      url: `despacho/pdf/certidaoArea/${despachoId}`
    })
    return data
  },

  async findByFiltroSelecaoAndProcesso ({ commit }, { idProcesso, idModelo }) {
    const data = await axios({
      method: 'get',
      url: `despacho/template/titulo/${idProcesso}/${idModelo}`
    })
    return data
  },

  async getDespachoWithJsonTitulo ({ commit }, { idProcesso }) {
    const data = await axios({
      method: 'get',
      url: `despacho/getDespachoWithJsonTitulo/${idProcesso}`
    })
    return data
  },

  async saveDadosCartorio ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      url: `despacho/salvarDadosCartorio`,
      data: dados
    })
    return data
  },

  async findByFilter ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      url: `despacho/findByFilter`,
      data: dados
    })
    return data
  },
  async criarNovaCertidao ({ commit }, despacho) {
    const data = await axios({
      method: 'POST',
      url: `despacho/salvarCertidao`,
      data: despacho
    })
    return data
  },
  async criarNovoOficioCcr ({ commit }, despacho) {
    const data = await axios({
      method: 'POST',
      url: `despacho/salvarOficio`,
      data: despacho
    })
    return data
  },
  async relatorioDespachoProcesso ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `despacho/getDespachoById/${dados.idProcesso}`,
      error: true
    })
    return data
  },
  async deleteCertidao ({ commit }, despachoId) {
    const data = await axios({
      method: 'DELETE',
      url: `despacho/deleteById/${despachoId}`
    })
    return data
  },
  async confirmarDadosCertidoes ({ commit }, processoId) {
    const data = await axios({
      method: 'GET',
      url: `despacho/confirmarDadosCertidoes/${processoId}`
    })
    return data
  },
  async findById ({ commit }, id) {
    const data = await axios({
      method: 'GET',
      url: `despacho/find/${id}`
    })
    return data
  },
  async validarTituloCertidao ({ commit }, despachoId) {
    const data = await axios({
      method: 'PATCH',
      url: `despacho/validarTituloCertidao/${despachoId}`
    })
    return data
  },
  async editarTituloCertidao ({ commit }, despacho) {
    const data = await axios({
      method: 'PATCH',
      url: `despacho/editarTituloCertidao`,
      data: despacho
    })
    return data
  },

  async getArrayTituloByProcessoId ({ commit }, processoId) {
    const data = await axios({
      method: 'GET',
      url: `despacho/pdf/titulos/${processoId}`
    })
    return data
  },

  async getOficioCcrByProcessoId ({ commit }, processoId) {
    const data = await axios({
      method: 'GET',
      responseType: 'arraybuffer',
      url: `despacho/pdf/oficio/${processoId}`
    })
    return data
  },

  async getDespachoWithData ({ commit }, { idProcesso, idModelo }) {
    const data = await axios({
      method: 'GET',
      url: `despacho/getDespachoWithData/${idProcesso}/${idModelo}`
    })
    return data
  },
  async getDespachoDinamicoWithData ({ commit }, { idProcesso, idModelo }) {
    const data = await axios({
      method: 'GET',
      url: `despacho/getDespachoDinamicoWithData/${idProcesso}/${idModelo}`
    })
    return data
  },
  async getDespachoDinamicoWithText ({ commit }, { idProcesso, textoDespacho }) {
    const data = await axios({
      method: 'POST',
      data: {idProcesso: idProcesso, textoDespacho: textoDespacho},
      url: `despacho/getDespachoDinamicoWithText`
    })
    return data
  },
  async criarDespacho ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `despacho/criarDespacho`
    })
    return data
  },
  async getPdfExtratoSentencaByIdProcessos ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      responseType: 'arraybuffer',
      url: `despacho/pdfExtratoSentenca`
    })
    return data
  },
  async processosJaCadastrados ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `despacho/processosJaCadastrados`
    })
    return data
  },
  async getDespachoOficioCcr ({ commit }, processoId) {
    const data = await axios({
      method: 'GET',
      url: `despacho/getDespachoOficioCcr/${processoId}`
    })
    return data
  },
  async getNumeroOficio ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: `despacho/numeroOficio/`
    })
    return data
  },
  async getDespachoRegistroImovel ({ commit }, { idProcesso, idModelo }) {
    const data = await axios({
      method: 'GET',
      url: `despacho/getDespachoRegistroImovel/${idProcesso}/${idModelo}`
    })
    return data
  },
  async getDespachoDadosImovel ({ commit }, { idProcesso }) {
    const data = await axios({
      method: 'GET',
      url: `despacho/getDespachoDadosImovel/${idProcesso}`
    })
    return data
  },
  async dadosImovel ({ commit }, processoId) {
    const data = await axios({
      method: 'GET',
      url: `despacho/oficio/dadosImovel/${processoId}`
    })
    return data
  },
  async processarTemplate ({ commit }, processoId) {
    const data = await axios({
      method: 'GET',
      url: `despacho/oficio/processarTemplate/${processoId}`
    })
    return data
  },
  async finalizaDespachoAssinatura ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `despacho/finalizar/assinatura`
    })
    return data
  },
  async finalizarImpressaoTitulo ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `despacho/finalizarImpressaoTitulo`
    })
    return data
  },
  async despachoRetornoImpressao ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `despacho/retorno/impressao`
    })
    return data
  },
  async finalizaDespachoOficio ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `despacho/finalizar/oficio`
    })
    return data
  },
  async findDespachosByIdProcesso ({ commit }, idProcesso) {
    const data = await axios({
      method: 'GET',
      url: `despacho/findDespachosByIdProcesso/${idProcesso}`
    })
    return data
  },
  async findUltimoByIdProcesso ({ commit }, idProcesso) {
    const data = await axios({
      method: 'GET',
      url: `despacho/findUltimo/processo/${idProcesso}`
    })
    return data
  },
  async criarDespachoMovimentarProcesso ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `despacho/criarDespachoMovimentarProcesso`
    })
    return data
  },
  async criarDespachoSuspensaoProcesso ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `despacho/criarDespachoSuspensaoProcesso`
    })
    return data
  }
}
const mutations = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/despacho.js